import { makeStyles } from '@material-ui/core/styles';


export const PanelUserMachineStyle = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
  
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 190,
    },
    TableCell: {
      color: '#0088FE',
      fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
      fontWeight: 'bold',
      fontSize: '17px',

  } ,  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end', // Alinea al final (derecha)
    paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
},
searchInputContainer: {
    display: 'flex',
    borderRadius: '20px 0px 0px 20px',
    height: '32px',
    fontSize: '16px',

    
},
searchInput: {
  border: '1px solid  #b6b7b7',
  borderRadius: '20px 0px 0px 20px',
  padding: '4px 8px',
  /* height: '100%', */  // Elimina o ajusta esta línea
  width: '100px',  // Ajusta el ancho al 100%
  fontSize: 'inherit',
  outline: 'none',
  flex: 1,
},
searchButton: {
    background: '#0088FE',
    color: 'white',
    borderRadius: '0px 50px 50px 0px',
    padding: '8px 16px',
    fontSize: '14px',
},
paper1: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    width:'100%'
  },
  card: {
    borderRadius: '15px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
},
  }));